<div class="profile-page">

  @if (loading) {
    <div class="loading-overlay">
      <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
    </div>
  }

  @if (!loading && profile) {

    <div class="profile-layout" [class.profile-layout--inactive]="!isMemberActive" (click)="closeTabMenu()">

      <aside class="info-panel desktop-only">
        <div class="info-card info-card--full">

          <div class="member-details-readonly" [class.member-details-readonly--inactive]="!isMemberActive">
          <div class="card-top-row">
            <h2 class="user-name">{{ profile.name }}</h2>
            <button class="icon-btn edit-btn" type="button"
                    [disabled]="!isMemberActive"
                    (click)="openEditPersonalInfo()" [title]="'fee.edit_personal_info' | translate">
              <mat-icon>edit</mat-icon>
            </button>
          </div>

          <div class="user-fields">
            <div class="field-row">
              <span class="field-label">{{ 'fee.member_id' | translate }}:</span>
              <span class="field-value">{{ memberIdentifier }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">{{ 'fee.passport_or_id_card' | translate }}:</span>
              <span class="field-value">{{ profile.passportId || '—' }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">{{ 'fee.date_of_birth' | translate }}:</span>
              <span class="field-value">{{ formatDate(profile.dateOfBirth) }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">{{ 'fee.mail' | translate }}:</span>
              <span class="field-value">{{ profile.email || '—' }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">{{ 'fee.phone' | translate }}:</span>
              <span class="field-value">{{ profile.phone || '—' }}</span>
            </div>
          </div>
          </div>

          <div class="card-divider"></div>

          @if (isScanMeUser) {
            <div class="field-row">
              <span class="field-label">{{ 'activity.status' | translate }}:</span>
              <span class="field-value status-text"
                    [class.status-text--inactive]="!isMemberActive">
                {{ (isMemberActive ? 'fee.active' : 'fee.deactivated') | translate }}
              </span>
            </div>
          } @else {
            <div class="status-toggle-row">
              <span class="status-text" [class.status-text--inactive]="!isMemberActive">
                {{ (isMemberActive ? 'fee.active' : 'fee.deactivated') | translate }}
              </span>
              <label class="toggle" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="isMemberActive" (change)="onToggleChange($event)">
                <span class="toggle-ui"></span>
              </label>
            </div>
          }

          <div class="card-divider"></div>

          <div class="member-details-readonly" [class.member-details-readonly--inactive]="!isMemberActive">
          <div class="emergency-section">
            <div class="section-header-row">
              <span class="section-label emergency-title">{{ 'fee.emergency_contact' | translate }}</span>
              <button class="icon-btn edit-btn" type="button"
                      [disabled]="!isMemberActive"
                      (click)="openEditEmergencyContact()" [title]="'fee.edit_emergency_contact' | translate">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
            @if (profile.emergencyContactName || profile.emergencyContactPhone || profile.emergencyContactEmail) {
              <div class="emergency-fields">
                @if (profile.emergencyContactName) {
                  <div class="field-row">
                    <span class="field-label">{{ 'user_card.name' | translate }}:</span>
                    <span class="field-value">{{ profile.emergencyContactName }}</span>
                  </div>
                }
                @if (profile.emergencyContactEmail) {
                  <div class="field-row">
                    <span class="field-label">{{ 'fee.mail' | translate }}:</span>
                    <span class="field-value">{{ profile.emergencyContactEmail }}</span>
                  </div>
                }
                @if (profile.emergencyContactPhone) {
                  <div class="field-row">
                    <span class="field-label">{{ 'fee.phone' | translate }}:</span>
                    <span class="field-value">{{ profile.emergencyContactPhone }}</span>
                  </div>
                }
              </div>
            } @else {
              <div class="emergency-empty">{{ 'fee.no_emergency_contact_set' | translate }}</div>
            }
            @if (showPaymentModeCard) {
              <div class="payment-mode-card">
                <div class="payment-mode-label">
                  {{ 'fee.payment_mode.prefix' | translate }}
                  <strong>{{ paymentModeValueKey | translate }}</strong>
                </div>
                @if (isBindingPaymentActive) {
                  <button class="btn-binding-cancel" type="button"
                          [disabled]="cancelingBinding"
                          (click)="cancelRecurringBinding()">
                    @if (cancelingBinding) {
                      <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
                    } @else {
                      <span>{{ 'fee.cancel_binding_payment' | translate }}</span>
                    }
                  </button>
                }
              </div>
            }
          </div>

          <div class="card-notify-wrap">
            <button class="btn-notify" type="button" [disabled]="sendingNotification || isNotificationBlockedByBusinessRules" (click)="sendNotification()">
              @if (sendingNotification) {
                <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
              } @else {
                {{ 'fee.send_notification' | translate }}
              }
            </button>
          </div>
          </div>

        </div>
      </aside>

      <main class="content-panel">
        <div class="subgroup-tabs-bar" [class.subgroup-tabs-bar--inactive]="!isMemberActive">
          <div class="tabs-scroll">
            @for (sg of tabSubgroups; track sg.id) {
              <div class="subgroup-tab" [class.active]="activeSubgroupId === sg.id" (click)="selectSubgroup(sg)">
                <span class="tab-label">
                  @if (sg.groupName) { {{ sg.groupName }} / {{ sg.name }} }
                  @else { {{ sg.name }} }
                </span>
                <button class="tab-menu-btn" type="button"
                        [disabled]="!isMemberActive"
                        (click)="toggleTabMenu(sg.id, $event)"
                        [title]="'fee.more_options' | translate">
                  <mat-icon>more_vert</mat-icon>
                </button>
                @if (openMenuId === sg.id && isMemberActive) {
                  <div class="tab-dropdown"
                       [style.top.px]="menuPosition?.top"
                       [style.left.px]="menuPosition?.left"
                       (click)="$event.stopPropagation()">
                    <button class="tab-dropdown__item" type="button"
                            (click)="goToSubgroup(sg); closeTabMenu()">
                      {{ 'fee.go_to_subgroup' | translate }}
                    </button>
                    <button class="tab-dropdown__item" type="button"
                            (click)="openEditPersonalInfo(); closeTabMenu()">
                      <span>{{ 'fee.edit_member_info' | translate }}</span>
                      <mat-icon class="tab-dropdown__icon">edit</mat-icon>
                    </button>
                    <button class="tab-dropdown__item" type="button"
                            (click)="openRemoveFromSubgroup(sg); closeTabMenu()">
                      <span>{{ 'fee.remove_from_subgroup' | translate }}</span>
                      <mat-icon class="tab-dropdown__icon">delete_outline</mat-icon>
                    </button>
                  </div>
                }
              </div>
            }
            @if (!isMobile && profile.subgroups.length >= minPageCountForNavigation) {
              <button class="btn-trs" (click)="nextPage()"
                      [ngStyle]="{'display': currentPage >= maxPage ? 'none' : ''}">
                <mat-icon class="nav-to-many">chevron_right</mat-icon>
              </button>
              <button class="btn-trs" (click)="prevPage()"
                      [ngStyle]="{'display': currentPage < maxPage ? 'none' : ''}">
                <mat-icon class="nav-to-many">chevron_left</mat-icon>
              </button>
            }
          </div>
          <button class="btn-register desktop-only" type="button"
                  [disabled]="!isMemberActive"
                  (click)="openRegisterSubgroup()">
            {{ 'fee.register_to_subgroup' | translate }}
          </button>
        </div>

        @if (activeSubgroup) {
          <div class="subgroup-info-banner desktop-only" [class.member-content--inactive]="!isMemberActive">
            <div class="info-banner-item">
              <span class="banner-label">{{ 'fee.mentor_name' | translate }}</span>
              <span class="banner-value">{{ activeSubgroup.mentorName || '—' }}</span>
            </div>
            <div class="info-banner-item">
              <span class="banner-label">{{ 'fee.start_date_end_date' | translate }}</span>
              <span class="banner-value">{{ formatDateRange(activeSubgroup) }}</span>
            </div>
            <div class="info-banner-item">
              <span class="banner-label">{{ 'fee.frequency' | translate }}</span>
              <span class="banner-value">{{ frequencyLabel(activeSubgroup.frequency) }}</span>
            </div>
            <div class="info-banner-item">
              <span class="banner-label">{{ 'fee.price' | translate }}</span>
              <span class="banner-value">{{ activeSubgroup.price | number }} {{ currencySymbol }}</span>
            </div>
            <div class="info-banner-item">
              <span class="banner-label">{{ 'fee.discount' | translate }}</span>
              <span class="banner-value">{{ discountLabel(activeSubgroup) }}</span>
            </div>
          </div>

          <div class="subgroup-info-mobile mobile-only" [class.member-content--inactive]="!isMemberActive">
            <button class="subgroup-info-toggle" type="button"
                    (click)="showSubgroupInfoMobile = !showSubgroupInfoMobile">
              <span>{{ 'fee.subgroup_information' | translate }}</span>
              <mat-icon class="toggle-chevron" [class.open]="showSubgroupInfoMobile">
                {{ showSubgroupInfoMobile ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </mat-icon>
            </button>
            @if (showSubgroupInfoMobile) {
              <div class="subgroup-info-cards">
                <hr class="subgroup-info-divider">
                <div class="si-card">
                  <span class="banner-label">{{ 'fee.mentor_name' | translate }}</span>
                  <span class="banner-value">{{ activeSubgroup.mentorName || '—' }}</span>
                </div>
                <div class="si-card">
                  <span class="banner-label">{{ 'fee.start_date_end_date' | translate }}</span>
                  <span class="banner-value">{{ formatDateRange(activeSubgroup) }}</span>
                </div>
                <div class="si-card">
                  <span class="banner-label">{{ 'fee.frequency' | translate }}</span>
                  <span class="banner-value">{{ frequencyLabel(activeSubgroup.frequency) }}</span>
                </div>
                <div class="si-card-row">
                  <div class="si-card si-card--half">
                    <span class="banner-label">{{ 'fee.price' | translate }}</span>
                    <span class="banner-value">{{ activeSubgroup.price | number }} {{ currencySymbol }}</span>
                  </div>
                  <div class="si-card si-card--half">
                    <span class="banner-label">{{ 'fee.discount' | translate }}</span>
                    <span class="banner-value">{{ discountLabel(activeSubgroup) }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <div class="payment-section" [class.member-content--inactive]="!isMemberActive">
          @if (filteredPayments.length === 0) {
            <div class="empty-payments">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"
                      stroke="#CBD5E1" stroke-width="1.5" stroke-linecap="round"/>
                <rect x="9" y="3" width="6" height="4" rx="1" stroke="#CBD5E1" stroke-width="1.5"/>
                <path d="M9 12h6M9 16h4" stroke="#CBD5E1" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <p>{{ 'fee.no_payment_records' | translate }}</p>
            </div>
          } @else {
            <table class="payment-table desktop-table">
              <thead>
                <tr>
                  <th>
                    <span class="month-header-with-icon">
                      {{ 'fee.month' | translate }}
                      <mat-icon class="month-sort-icon">swap_vert</mat-icon>
                    </span>
                  </th>
                  <th>{{ 'fee.frequency' | translate }}</th>
                  <th>{{ 'fee.price' | translate }}</th>
                  <th>{{ 'fee.discount' | translate }}</th>
                  <th>{{ 'fee.total' | translate }}</th>
                  <th>{{ 'fee.due' | translate }}</th>
                  @if (!isScanMeUser) {
                    <th>{{ 'activity.status' | translate }}</th>
                  }
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (p of displayedPayments; track $index) {
                  <tr>
                    <td class="cell-month">{{ p.month | localizedMonth }}</td>
                    <td>{{ frequencyLabel(p.frequency) }}</td>
                    <td>{{ p.price | number }} {{ currencySymbol }}</td>
                    <td>{{ paymentDiscountLabel(p) }}</td>
                    <td>{{ p.total | number }} {{ currencySymbol }}</td>
                    <td>{{ (p.status === 'PAID' ? 0 : p.due) | number }} {{ currencySymbol }}</td>
                    @if (isScanMeUser) {
                      <td class="cell-action">
                        @if (p.status === 'PAID') {
                          <span class="status-badge status-paid">
                            <mat-icon class="status-icon">check_circle</mat-icon> {{ 'fee.paid' | translate }}
                          </span>
                        } @else if (p.status === 'PENDING') {
                          <span class="status-badge status-pending">
                            <mat-icon class="status-icon status-icon-pending">fiber_manual_record</mat-icon> {{ 'fee.status.pending' | translate }}
                          </span>
                        }
                      </td>
                    } @else {
                      <td>
                        <span class="status-badge" [ngClass]="paymentStatusClass(p.status)">
                          @if (p.status === 'PAID') {
                            <mat-icon class="status-icon">check_circle</mat-icon> {{ 'fee.paid' | translate }}
                          } @else if (p.status === 'PENDING') {
                            <mat-icon class="status-icon status-icon-pending">fiber_manual_record</mat-icon> {{ 'fee.status.pending' | translate }}
                          } @else {
                            {{ p.status | titlecase }}
                          }
                        </span>
                      </td>
                      <td>
                        @if (showEndControl(p)) {
                          <button class="btn-end" type="button"
                                  [class.btn-end--ended]="isSubgroupBillingEnded"
                                  [disabled]="isEndButtonDisabled(p)"
                                  (click)="endPeriod(p)">{{ endButtonLabel(p) }}</button>
                        }
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>

            <div class="payment-cards mobile-only">
              @for (p of displayedPayments; track $index) {
                <div class="payment-card">

                  <div class="pc-row-header">
                    <div class="pf-item">
                      <span class="pf-label">{{ 'fee.month' | translate }}</span>
                      <span class="pf-value pf-value--bold">{{ p.month | localizedMonth }}</span>
                    </div>
                    @if (isScanMeUser) {
                      @if (p.status === 'PAID') {
                        <span class="status-badge status-paid">
                          <mat-icon class="status-icon">check_circle</mat-icon> {{ 'fee.paid' | translate }}
                        </span>
                      } @else if (p.status === 'PENDING') {
                        <span class="status-badge status-pending">
                          <mat-icon class="status-icon status-icon-pending">fiber_manual_record</mat-icon> {{ 'fee.status.pending' | translate }}
                        </span>
                      }
                    } @else {
                      <span class="status-badge" [ngClass]="paymentStatusClass(p.status)">
                        @if (p.status === 'PAID') {
                          <mat-icon class="status-icon">check_circle</mat-icon> {{ 'fee.paid' | translate }}
                        } @else if (p.status === 'PENDING') {
                          <mat-icon class="status-icon status-icon-pending">fiber_manual_record</mat-icon> {{ 'fee.status.pending' | translate }}
                        } @else {
                          {{ p.status | titlecase }}
                        }
                      </span>
                    }
                  </div>

                  <div class="pf-item">
                    <span class="pf-label">{{ 'fee.frequency' | translate }}</span>
                    <span class="pf-value pf-value--bold">{{ frequencyLabel(p.frequency) }}</span>
                  </div>
                  <div class="pf-item">
                    <span class="pf-label">{{ 'fee.price' | translate }}</span>
                    <span class="pf-value pf-value--bold">{{ p.price | number }} {{ currencySymbol }}</span>
                  </div>
                  <div class="pf-item">
                    <span class="pf-label">{{ 'fee.discount' | translate }}</span>
                    <span class="pf-value pf-value--bold">{{ paymentDiscountLabel(p) }}</span>
                  </div>
                  <div class="pf-item">
                    <span class="pf-label">{{ 'fee.total' | translate }}</span>
                    <span class="pf-value pf-value--bold">{{ p.total | number }} {{ currencySymbol }}</span>
                  </div>
                  <div class="pf-item">
                    <span class="pf-label">{{ 'fee.due' | translate }}</span>
                    <span class="pf-value pf-value--bold">{{ (p.status === 'PAID' ? 0 : p.due) | number }} {{ currencySymbol }}</span>
                  </div>

                  @if (showEndControl(p)) {
                    <button class="btn-end mobile-end" type="button"
                            [class.btn-end--ended]="isSubgroupBillingEnded"
                            [disabled]="isEndButtonDisabled(p)"
                            (click)="endPeriod(p)">{{ endButtonLabel(p) }}</button>
                  }

                </div>
              }
            </div>
            @if (hasMorePayments) {
              <div class="fee-load-more-row d-flex justify-content-center mt-4 flex-direction-row gap-10px">
                @if (!isLoading) {
                  <button class="load-history-button" type="button" (click)="loadMore()">{{ 'my_team.load_more' | translate }}</button>
                  <div class="search-loader">
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                }
              </div>
            }
          }
        </div>

        <div class="mobile-bottom-strip mobile-only">
          <div class="mob-name-toggle">
            <span class="mob-user-name">{{ profile.name }}</span>
            @if (isScanMeUser) {
              <span class="status-text" [class.status-text--inactive]="!isMemberActive">
                {{ (isMemberActive ? 'fee.active' : 'fee.deactivated') | translate }}
              </span>
            } @else {
              <div class="mob-status-toggle">
                <span class="status-text" [class.status-text--inactive]="!isMemberActive">
                  {{ (isMemberActive ? 'fee.active' : 'fee.deactivated') | translate }}
                </span>
                <label class="toggle" (click)="$event.stopPropagation()">
                  <input type="checkbox" [checked]="isMemberActive" (change)="onToggleChange($event)">
                  <span class="toggle-ui"></span>
                </label>
              </div>
            }
          </div>
          <button class="btn-notify" type="button" [disabled]="sendingNotification || isNotificationBlockedByBusinessRules" (click)="sendNotification()">
            @if (sendingNotification) {
              <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
            } @else {
              {{ 'fee.send_notification' | translate }}
            }
          </button>
          <button class="btn-more-info" type="button" (click)="showMobileInfo = true">
            {{ 'fee.more_information' | translate }}
          </button>
        </div>

      </main>
    </div>

    <div class="mobile-info-overlay mobile-only" [class.open]="showMobileInfo">
      <div class="mob-info-header">
        <button class="mob-back-btn" type="button" (click)="showMobileInfo = false">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="mob-info-title">{{ 'fee.more_information' | translate }}</span>
        <div class="mob-header-right">
          <div class="mob-header-avatar">
            <img [src]="getAvatarUrl(profile.avatarUrl)" alt="avatar"
                 (error)="$any($event.target).onerror=null; $any($event.target).src=defaultAvatar">
          </div>
          <button class="mob-hamburger" type="button">
            <mat-icon>menu</mat-icon>
          </button>
        </div>
      </div>

      <div class="mob-info-body">
        <div class="info-card" [class.info-card--inactive]="!isMemberActive">

          <div class="member-details-readonly" [class.member-details-readonly--inactive]="!isMemberActive">
          <div class="card-top-row">
            <h2 class="user-name">{{ profile.name }}</h2>
            <button class="icon-btn edit-btn" type="button"
                    [disabled]="!isMemberActive"
                    (click)="openEditPersonalInfo()">
              <mat-icon>edit</mat-icon>
            </button>
          </div>

          <div class="user-fields">
            <div class="field-row">
              <span class="field-label">{{ 'fee.member_id' | translate }}:</span>
              <span class="field-value">{{ memberIdentifier }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">{{ 'fee.passport_or_id_card' | translate }}:</span>
              <span class="field-value">{{ profile.passportId || '—' }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">{{ 'fee.date_of_birth' | translate }}:</span>
              <span class="field-value">{{ formatDate(profile.dateOfBirth) }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">{{ 'fee.mail' | translate }}:</span>
              <span class="field-value">{{ profile.email || '—' }}</span>
            </div>
            <div class="field-row">
              <span class="field-label">{{ 'fee.phone' | translate }}:</span>
              <span class="field-value">{{ profile.phone || '—' }}</span>
            </div>
          </div>
          </div>

          <div class="card-divider"></div>

          @if (isScanMeUser) {
            <div class="field-row">
              <span class="field-label">{{ 'activity.status' | translate }}:</span>
              <span class="field-value status-text"
                    [class.status-text--inactive]="!isMemberActive">
                {{ (isMemberActive ? 'fee.active' : 'fee.deactivated') | translate }}
              </span>
            </div>
          } @else {
            <div class="status-toggle-row">
              <span class="status-text" [class.status-text--inactive]="!isMemberActive">
                {{ (isMemberActive ? 'fee.active' : 'fee.deactivated') | translate }}
              </span>
              <label class="toggle" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="isMemberActive" (change)="onToggleChange($event)">
                <span class="toggle-ui"></span>
              </label>
            </div>
          }

          <div class="card-divider"></div>

          <div class="member-details-readonly" [class.member-details-readonly--inactive]="!isMemberActive">
          <div class="emergency-section">
            <div class="section-header-row">
              <span class="section-label emergency-title">{{ 'fee.emergency_contact' | translate }}</span>
              <button class="icon-btn edit-btn" type="button"
                      [disabled]="!isMemberActive"
                      (click)="openEditEmergencyContact()">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
            @if (profile.emergencyContactName || profile.emergencyContactPhone || profile.emergencyContactEmail) {
              <div class="emergency-fields">
                @if (profile.emergencyContactName) {
                  <div class="field-row">
                    <span class="field-label">{{ 'user_card.name' | translate }}:</span>
                    <span class="field-value">{{ profile.emergencyContactName }}</span>
                  </div>
                }
                @if (profile.emergencyContactEmail) {
                  <div class="field-row">
                    <span class="field-label">{{ 'fee.mail' | translate }}:</span>
                    <span class="field-value">{{ profile.emergencyContactEmail }}</span>
                  </div>
                }
                @if (profile.emergencyContactPhone) {
                  <div class="field-row">
                    <span class="field-label">{{ 'fee.phone' | translate }}:</span>
                    <span class="field-value">{{ profile.emergencyContactPhone }}</span>
                  </div>
                }
              </div>
            } @else {
              <div class="emergency-empty">{{ 'fee.no_emergency_contact_set' | translate }}</div>
            }
            @if (showPaymentModeCard) {
              <div class="payment-mode-card">
                <div class="payment-mode-label">
                  {{ 'fee.payment_mode.prefix' | translate }}
                  <strong>{{ paymentModeValueKey | translate }}</strong>
                </div>
                @if (isBindingPaymentActive) {
                  <button class="btn-binding-cancel" type="button"
                          [disabled]="cancelingBinding"
                          (click)="cancelRecurringBinding()">
                    @if (cancelingBinding) {
                      <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
                    } @else {
                      <span>{{ 'fee.cancel_binding_payment' | translate }}</span>
                    }
                  </button>
                }
              </div>
            }
          </div>

          <div class="card-notify-wrap">
            <button class="btn-notify" type="button" [disabled]="sendingNotification || isNotificationBlockedByBusinessRules" (click)="sendNotification()">
              @if (sendingNotification) {
                <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
              } @else {
                {{ 'fee.send_notification' | translate }}
              }
            </button>
          </div>
          </div>

        </div>
      </div>
    </div>

  }

</div>
